import React from 'react'
import PropTypes from 'prop-types'
import { MenuItem } from '@mui/material'
import MuiSelectWrapper from 'gui/components/common/MuiSelect'
import SORT_TYPE_OPTIONS from './options'
// import './index.scss'

/**
 * Component for content sort type select
 * @param {Object} props The props
 * @param {String} props.onChange An options onChange funciton
 * @param {String} props.value The value
 * @param {String} props.label The label
 * @param {String} props.name The DOM element name
 * @param {String} props.className The classname
 * @param {String} props.defaultValue The default value
 * @param {String} props.required When true the value is required
 * @param {String} props.id The DOM element id
 * @param {Boolean} props.disabled When true component is disabled
 */
export default function ContentSortType (props) {
  const { id, value, defaultValue, label, name, className, onChange, required, disabled } = props
  return (
    <MuiSelectWrapper
      id={id}
      name={name}
      className={className}
      label={label}
      onChange={onChange}
      value={value || defaultValue || ''}
      required={required}
      disabled={disabled}
    >
      {SORT_TYPE_OPTIONS.map((option) => (
        <MenuItem value={option.get('value')} key={`content-type-${option.get('value')}`}>
          {option.get('label')}
        </MenuItem>
      ))}
    </MuiSelectWrapper>
  )
}

ContentSortType.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  defaultValue: PropTypes.string,
  required: PropTypes.bool,
  id: PropTypes.string,
  disabled: PropTypes.bool,
}

ContentSortType.defaultProps = {
  label: 'Sort By',
  name: 'sort',
}
